// Module
var code = "<template>\r\n    <div slot=\"content\">\r\n        <p show.bind=\"IsSuccess\">Activate success. You can close this page now.</p>\r\n    </div>\r\n</template>";
// Exports
export default code;